import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { NgIf, NgFor } from '@angular/common';
import { RouterLink } from '@angular/router';

import { OrganizationHierarchyChildren, OrganizationHierarchyParent } from '../../../../models/organization-hierarchy';

@Component({
	selector: 'copo-organization-flow-chart-element',
	templateUrl: './org-flow-chart-element.component.html',
	styleUrl: './org-flow-chart-element.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [RouterLink, NgIf, MatIconModule, NgFor]
})
export class OrgFlowChartElementComponent {
	@Input() organization?: OrganizationHierarchyChildren;
	@Input() parent?: OrganizationHierarchyParent;
	@Input() currentId?: number;
}
